import classNames from "classnames";
import { FunctionComponent } from "react";

interface PageTitleProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

const PageTitle: FunctionComponent<PageTitleProps> = ({ className, ...divProps }) => {
  return <div className={classNames("font-bold text-2xl leading-none", className)} {...divProps}></div>;
};

export default PageTitle;
